import { Grid, Stack, Typography, useTheme } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { SmallCard } from 'theme/elements/Cards';
import { useNavigate } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';

export const DigitalBalanceRequests = () => {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const navigate = useNavigate();

	const handleCardClick = () => {
		navigate(`/${pagesEnum.DIGITAL_BALANCE_REQUESTS}`);
	};

	return (
		<Stack>
			<Typography variant="h4" sx={{ fontWeight: 700, color: theme.palette.common.black, marginBottom: 2 }}>
				{t('page.dashboard.digitalBalanceRequests.title')}
			</Typography>
			<Grid container spacing={4} columns={5}>
				<Grid item xs={8} sm={'auto'} sx={{ cursor: 'pointer' }}>
					<SmallCard
						styleObj={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							alignItems: 'center',
							minHeight: 115,
						}}
						handleClick={handleCardClick}
					>
						<Stack>
							<Typography variant="boldBody4">{t('page.dashboard.digitalBalanceRequests.card.title')}</Typography>
						</Stack>
						<img src="/icons/arrow-left.svg" style={{ marginRight: '10px' }} />
					</SmallCard>
				</Grid>
			</Grid>
		</Stack>
	);
};
